import WidgetEventBus from './widget-event-bus'

export type EventName = string;
export interface Publisher {
  name: string;
}
export type Callback = (publisher: Publisher, ...args: any[]) => void;
export interface Subscription {
  eventName: EventName;
  callback: Callback;
  unsubscribe: () => void;
}

export interface EventBus {
  subscribe(eventName: EventName, callback: Callback): Subscription;
  publish(eventName: EventName, publisher: Publisher, ...args: any[]): void;
}

// eslint-disable-next-line import/prefer-default-export
export const getOrCreateEventBus = (): EventBus => {
  const currentWindow: any = window
  const eventBus = currentWindow.yotpoWidgetsContainer.yotpo_event_bus
  if (eventBus) {
    return eventBus as EventBus
  }

  const newEventBus = new WidgetEventBus(true)
  currentWindow.yotpoWidgetsContainer.yotpo_event_bus = newEventBus
  return newEventBus
}
